export default  {
    state:{
        readtype:"",
        patinfo:{
        },
        readCard:{
            name:"",
            xb:"",
            csrq:"",
            idno:"",
            dz:"",
            lxdh:"",
            cardtype:""
        },
        inpatientno:""

    },
    actions: {
        changePatinfo:(context,para)=>{
            context.commit('changePatinfo',para)
        },

        changeReadCard:(context,para)=>{
            context.commit('changeReadCard',para)
        },

        changeInpatientno:(context,para)=>{
            context.commit('changeInpatientno',para)
        },

        clearPatinfo:(context)=>{
            context.commit('clearPatinfo')
        }
    },
    mutations: {
        changePatinfo:(state,para)=>{
            state.patinfo =   para  
        },

        changeReadCard:(state,para)=>{
            state.readCard.name =   para.name 
            state.readCard.xb = para.xb
            state.readCard.csrq = para.csrq 
            state.readCard.idno = para.idno
            state.readCard.dz = para.dz 
            state.readCard.lxdh = para.lxdh 
            state.readCard.cardtype = para.cardtype
        },

        changeInpatientno:(state,para)=>{
            state.inpatientno = para
        },

        clearPatinfo:(state)=>{
            state.patinfo =   {}  
            state.readCard={
                name:"",
                patXb:"",
                patCsrq:"",
                patIdno:"",
                patDz:"",
                patLxdh:"",
                cardtype:""
            }
            
            state.inpatientno =""
        }
    }
}